<template>
    <div>
        <group-element
                :selectable="movingElement"
                :movable="!isReadOnly && movingElement"
                :resizable="!isReadOnly && movingElement"
                :deletable="!isReadOnly"
                connectable
                :id.sync="value.elementView.id"
                :x.sync="value.elementView.x"
                :y.sync="value.elementView.y"
                :width.sync="value.elementView.width"
                :height.sync="value.elementView.height"
                :angle.sync="value.elementView.angle"
                :customMoveActionExist="isCustomMoveExist"
                v-on:customMoveAction="delayedMove"
                v-on:moveShape="onMoveShape"
                v-on:selectShape="selectedActivity"
                v-on:deSelectShape="deSelectedActivity"
                v-on:removeShape="onRemoveShape"
                v-on:dblclick="openPanel"
                v-on:addedToGroup="onAddedToGroup"
                :label="!value.isVO && !value.isAggregateRoot ? name : ''"
                :image="setImg"
                :_style="{
                    'label-angle':value.elementView.angle,
                    'font-weight': 'bold', 'font-size': '14',
                    'vertical-align': 'top'
                }"
        >
            <!--v-on:dblclick="$refs['dialog'].open()"-->
            <geometry-rect
                    :_style="{
                        'fill-r': 1,
                        'fill-cx': .1,
                        'fill-cy': .1,
                        'stroke-width': 1.4,
                        'stroke': '#ffffff',
                        'fill-opacity': 1,
                        r: '1'
                    }"
            ></geometry-rect>

            <!-- title -->
            <sub-elements>
                <rectangle-element
                        :sub-width="'100%'"
                        :sub-height="titleH"
                        :subStyle="{
                            'stroke': '#FFA400',
                            'fill': '#FFA400',
                            'fill-opacity': 1,
                        }"
                        :image="setImg"
                ></rectangle-element>
                <text-element
                        v-if="value.isAggregateRoot"
                        :sub-width="'100%'"
                        :sub-height="titleH/2"
                        :sub-top="0"
                        :sub-left="0"
                        :text="'<< AggregateRoot >>'"
                ></text-element>
                <text-element
                        v-if="value.isVO"
                        :sub-width="'100%'"
                        :sub-height="titleH/2"
                        :sub-top="0"
                        :sub-left="0"
                        :text="'<< ValueObject >>'"
                ></text-element>
                <text-element
                        v-if="value.isVO || value.isAggregateRoot"
                        :sub-width="'100%'"
                        :sub-height="titleH"
                        :sub-top="10"
                        :sub-left="0"
                        :text.sync="name"
                        :subStyle="{
                            'font-size': '14', 'font-weight': 'bold',
                        }"
                ></text-element>
            </sub-elements>

            <!-- attribute -->
            <sub-elements v-if="value.fieldDescriptors">
                <rectangle-element
                        :sub-width="'100%'"
                        :sub-height="fieldH"
                        :sub-top="titleH"
                        :subStyle="{
                            'stroke': '#050038',
                            'fill': '#050038',
                            'fill-opacity': 1,
                        }"
                        :image="setImg"
                ></rectangle-element>
            </sub-elements>

            <!-- operation -->
            <sub-elements v-if="value.operations">
                <rectangle-element
                        :sub-width="'100%'"
                        :sub-height="methodH"
                        :sub-top="subEdgeH"
                        :subStyle="{
                            'stroke': '#7CAFC4',
                            'fill': '#7CAFC4',
                            'fill-opacity': 1,
                            'z-index': -1
                        }"
                        :image="setImg"
                ></rectangle-element>
            </sub-elements>

            <uml-sub-controller 
                    :value="value" 
            ></uml-sub-controller>
        </group-element>

        <div v-if="value.fieldDescriptors">
            <div v-for="(attr, index) in value.fieldDescriptors" :key="'a'+index">
                <uml-class-text
                        v-model="value"
                        :type="'attribute'"
                        :readOnly="isReadOnly"
                        :styles="{
                            'name': attr.name,
                            'index': index,
                            'x': value.elementView.x,
                            'y': value.elementView.y,
                            'label': attributeLabels[index],
                            'width': value.elementView.width - 20,
                            'height': value.elementView.height,
                            'titleH': titleH,
                            'subEdgeH': subEdgeH,
                        }"
                ></uml-class-text>
            </div>
        </div>

        <div v-if="value.operations">
            <div v-for="(item, index) in value.operations" :key="'method'+index">
                <uml-class-text
                        v-model="value"
                        :type="'operation'"
                        :readOnly="isReadOnly"
                        :styles="{
                            'name': item.name,
                            'index': index,
                            'x': value.elementView.x,
                            'y': value.elementView.y,
                            'label': operationLabels[index],
                            'width': value.elementView.width - 20,
                            'height': value.elementView.height,
                            'titleH': titleH,
                            'subEdgeH': subEdgeH,
                        }"
                ></uml-class-text>
            </div>
        </div>

        <uml-class-panel
                v-if="propertyPanel"
                v-model="value"
                :entities="canvasbase.value"
                :img="imgSrc"
                @close="closePanel"
        ></uml-class-panel>
    </div>
</template>

<script>
    import Element from './UMLClassElement'

    var changeCase = require('change-case');
    var pluralize = require('pluralize');

    export default {
        mixins: [Element],
        name: 'uml-class-definition',
        props: {},
        computed: {
            imgSrc() {
                return `${window.location.protocol + "//" + window.location.host}/static/image/symbol/entity.png`
            },
            defaultStyle() {
                return {}
            },
            className() {
                return 'org.uengine.uml.model.Class'
            },
            createNew(elementId, x, y, width, height, angle) {
                return {
                    _type: this.className(),
                    name: '',
                    namePascalCase: '',
                    nameCamelCase: '',
                    namePlural: '',
                    fieldDescriptors: [],
                    operations: [],
                    elementView: {
                        '_type': this.className(),
                        'id': elementId,
                        'x': x,
                        'y': y,
                        'width': 200,
                        'height': 100,
                        'style': JSON.stringify({}),
                        'angle': angle,
                    },
                    // drawer: false,
                    selected: false,
                    // editing: false,
                    parentOperations: [],
                    relationType: null,
                    isVO: false,
                    relations: [],
                    groupElement: null,
                    isAggregateRoot: false,
                }
            },
            name() {
                try {
                    return this.value.name
                } catch (e) {
                    return "";
                }
            },
            attributeY() {
                try {
                    var me = this
                    var arr = []
                    var attrY = me.value.elementView.y - me.value.elementView.height/2 + 45
                    if (me.value.fieldDescriptors.length > 0) {
                        me.value.fieldDescriptors.forEach(function (item, idx) {
                            arr.push(attrY + (idx * 20))
                        })
                    }
                    return arr
                } catch (e) {
                    return "";
                }
            },
            operationY() {
                try {
                    var me = this
                    var arr = []
                    var operationY = me.value.elementView.y + me.value.elementView.height/2
                    if (me.value.operations.length > 0) {
                        me.value.operations.forEach(function (item, idx) {
                            arr.push(operationY - ((me.value.operations.length - idx) * 20))
                        })
                    }
                    return arr
                } catch (e) {
                    return "";
                }
            },
            attributeLabels() {
                try {
                    var me = this
                    var arr = []
                    if (me.value.fieldDescriptors.length > 0) {
                        me.value.fieldDescriptors.forEach(function (item) {
                            var label = item.label ? item.label : '- ' + item.name + ': ' + item.className
                            arr.push(label)
                        })
                    }
                    return arr
                } catch (e) {
                    return "";
                }
            },
            operationLabels() {
                try {
                    var me = this
                    var arr = []
                    if (me.value.operations.length > 0) {
                        me.value.operations.forEach(function (item) {
                            var label = item.label ? item.label : '+' + item.name + '()'
                            arr.push(label)
                        })
                    }
                    return arr
                } catch (e) {
                    return "";
                }
            },
        },
        data: function () {
            return {
                titleH: 30,     // title 영역 높이
                subEdgeH: 70,   // method 영역 시작 높이
                fieldH: 50,     // field 영역 높이 (value.elementView.height - titleH)
                methodH: 30,    // method 영역 높이 (value.elementView.height - subEdgeH)
            };
        },
        created: function () {
            var me = this

            if(!me.value.operations || me.value.operations == null || me.value.operations == undefined) {
                me.value.operations = []
            }
            if(me.value.operations.length > 0) {
                me.value.operations.forEach(function(item) {
                    if(item.returnType == "") {
                        item.returnType = "void"
                        item.label += "void"
                    }
                })
            }

            
            if(me.value.isVO || me.value.isAggregateRoot) {
                me.titleH = 50
            }

            if(me.value.fieldDescriptors.length > 0) {
                me.subEdgeH = (me.value.fieldDescriptors.length * 20) + me.titleH + 15
                var height = me.titleH + (me.value.fieldDescriptors.length * 20) + 30
                
                if(me.value.operations.length > 0) {
                    height += me.value.operations.length * 20
                }
                
                if(me.value.elementView.height < height) {
                    me.value.elementView.height = height
                }
                me.fieldH = me.value.elementView.height - me.titleH
                me.methodH = me.value.elementView.height - me.subEdgeH
            } else {
                me.subEdgeH = 70;
                me.fieldH = 50;
                me.methodH = 30;
            }
        },
        watch: {
            // name: {
            //     deep: true,
            //     handler(newVal, oldVal) {
            //         var me = this;
            //         if(newVal != oldVal) {
            //             console.log(newVal)
            //             me.value.namePascalCase = changeCase.pascalCase(newVal);
            //             me.value.nameCamelCase = changeCase.camelCase(newVal);
            //             me.value.namePlural = pluralize(newVal);
            //             Object.values(me.value.relations).forEach(function(item) {
            //                 if(item) {
            //                     if(item.to == me.value.elementView.id) {
            //                         item.toName = newVal
            //                         item.name = me.value.nameCamelCase
            //                     }
            //                     if(item.from == me.value.elementView.id) {
            //                         item.fromName = newVal
            //                     }
            //                 }
            //             })
            //             // me.refresh()
            //         }
            //     }
            // },
            "value.fieldDescriptors": function () {
                var me = this
                me.setHeight()
            },
        },
        mounted: function () {
            var me = this

            this.$EventBus.$on(`${me.value.elementView.id}`, function (obj) {
                // add
                if (obj.action == "addRelation" && obj.element && obj.element.sourceElement && obj.element.targetElement) {
                    var item = {
                        'id': obj.element.relationView.id,
                        'fromName': obj.element.sourceElement.namePascalCase,
                        'toName': obj.element.targetElement.namePascalCase,
                        'from': obj.element.from,
                        'to': obj.element.to,
                        'sourceMultiplicity': obj.element.sourceMultiplicity,
                        'targetMultiplicity': obj.element.targetMultiplicity,
                        'relationType': obj.element.relationType,
                        'targetType': obj.element.targetElement._type,
                    }
                    var index = Object.values(me.value.relations).findIndex((relation) => 
                        relation.from == item.from && relation.to == item.to
                    );
                    if(index == -1 && item.from && item.to) {
                        me.value.relations.push(item)
                    }
                    if(index != -1 && item.from && item.to) {
                        me.value.relations[index] = obj.element
                    }
                    if(obj.element.from == me.value.elementView.id && obj.element.relationType.includes('Generalization')) {
                        me.value.parentOperations = obj.element.targetElement.operations;
                        me.value.relationType = obj.element.relationType;
                    }
                    if(obj.element.from == me.value.elementView.id && !obj.element.relationType.includes('Generalization')) {
                        me.addAttribute(obj.element)
                    }
                }
                
                // delete
                if (obj.action == "deleteRelation" && obj.element && obj.element.sourceElement && obj.element.targetElement) {
                    var idx = -1
                    me.value.relations.forEach(function(item, _idx) {
                        if(item.id) {
                            if(item.id == obj.element.relationView.id) {
                                idx = _idx
                            }
                        } else {
                            if(item.relationView.id == obj.element.relationView.id) {
                                idx = _idx
                            }
                        }
                    })
                    if(idx != -1) {
                        me.value.relations.splice(idx, 1);
                    }

                    if(obj.element.to == me.value.elementView.id && obj.element.relationType.includes('Generalization')) {
                        me.value.parentOperations = [];
                        me.value.relationType = null;
                    }

                    if(obj.element.from == me.value.elementView.id && !obj.element.relationType.includes('Generalization')) {
                        var index = -1
                        me.value.fieldDescriptors.forEach(function(attr, idx) {
                            if (attr.className == obj.element.targetElement.namePascalCase && attr.isKey == false) {
                                index = idx
                            }
                        })
                        if(index != -1) {
                            me.value.fieldDescriptors.splice(index, 1)
                        }
                    }
                }

                // edit
                if (obj.action == "editRelationInfo" && obj.element && obj.element.sourceElement && obj.element.targetElement) {
                    
                    if(obj.element.from == me.value.elementView.id && obj.element.relationType.includes('Generalization')) {
                        me.value.parentOperations = obj.element.targetElement.operations;
                        me.value.relationType = obj.element.relationType;
                        var index = -1
                        me.value.fieldDescriptors.forEach(function(attr, idx) {
                            if (attr.className.includes(obj.element.targetElement.namePascalCase)) {
                                index = idx
                            }
                        })
                        if(index != -1) {
                            me.value.fieldDescriptors.splice(index, 1)
                        }
                    }

                    if(obj.element.from == me.value.elementView.id && !obj.element.relationType.includes('Generalization')) {
                        me.addAttribute(obj.element)
                    }
                }

            })
        },
        methods: {
            setHeight() {
                var me = this
                var height = 0
                if(me.value.isVO || me.value.isAggregateRoot) {
                    me.titleH = 50
                    height = 80
                } else {
                    me.titleH = 30
                    height = 60
                }
                if(me.value.fieldDescriptors && me.value.fieldDescriptors.length > 0) {
                    height += me.value.fieldDescriptors.length * 20
                } else {
                    height += 50
                }
                if(me.value.operations && me.value.operations.length > 0) {
                    height += me.value.operations.length * 20
                } else {
                    height += 30
                }
                me.value.elementView.height = height
                me.fieldH = height - me.titleH
                if(!me.value.operations || me.value.operations.length < 1) {
                    me.methodH = 30
                } else {
                    me.methodH = me.value.operations.length * 20 + 15
                }
                me.subEdgeH = height - me.methodH
            },
            addAttribute(el) {
                var me = this
                if(el.name == '') {
                    return
                }

                // var index = me.value.relations.findIndex((obj) => obj.id == el.relationView.id )
                var idx = -1
                me.value.fieldDescriptors.findIndex(function(attr, _idx) {
                    if(attr.classId) {
                        if(attr.classId == el.to || pluralize(attr.name) == pluralize(el.name)) {
                            idx = _idx
                        }
                    }
                })

                if(idx == -1) {
                    var obj = {
                        "_type": "org.uengine.uml.model.FieldDescriptor",
                        "name": el.name,
                        "className": el.targetElement.namePascalCase,
                        "isKey": false,
                        "isVO": el.targetElement.isVO,
                        "namePascalCase": changeCase.pascalCase(el.name),
                        "nameCamelCase": changeCase.camelCase(el.name),
                        "label": "- "+ el.name + ": " + el.targetElement.namePascalCase,
                        "classId": el.to,
                        "isList": false,
                    }
                    if((el.relationType.includes('Aggregation') || el.relationType.includes('Composition')) && el.sourceMultiplicity == '1' && (el.targetMultiplicity == '1..n' || el.targetMultiplicity == '0..n')) {
                        obj.isList = true;
                        obj.name = pluralize(obj.name);
                        obj.label = "- "+ pluralize(obj.name) + ": " + obj.namePascalCase;
                    }
                    me.value.fieldDescriptors.push(obj)
                } else {
                    me.value.fieldDescriptors[idx].name = el.name
                    me.value.fieldDescriptors[idx].label = "- "+ el.name + ": " + el.targetElement.namePascalCase
                    me.value.fieldDescriptors[idx].classId = el.to

                    if((el.relationType.includes('Aggregation') || el.relationType.includes('Composition')) && el.sourceMultiplicity == '1' && (el.targetMultiplicity == '1..n' || el.targetMultiplicity == '0..n')) {
                        me.value.fieldDescriptors[idx].name = pluralize(el.name)
                        me.value.fieldDescriptors[idx].isList = true
                        me.value.fieldDescriptors[idx].className = "List<" + el.targetElement.namePascalCase + ">"
                        me.value.fieldDescriptors[idx].label = "- "+ pluralize(el.name) + ": List<" + el.targetElement.namePascalCase + ">"
                    }
                }
            }
        }
    }
</script>


<style scoped lang="scss" rel="stylesheet/scss">
</style>
